import { render } from "./v-student.vue?vue&type=template&id=31219c4e"
import script from "./v-student.vue?vue&type=script&lang=js"
export * from "./v-student.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\vue\\e-justice-sud-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__